import { cloneDeep } from 'lodash-es';
import { PAGE_URL } from 'client/site-modules/shared/constants/page-urls';
import {
  ELECTRIC_CAR_INCENTIVES_BREADCRUMBS,
  ELECTRIC_CAR_STATE_INCENTIVES_BREADCRUMBS,
  INCENTIVES_BREADCRUMBS,
} from 'site-modules/shared/constants/incentives';
import { getCarTypeNameBySlug } from './car-type-name-by-slug';

export const getIncentivesMakeBreadcrumbs = makeName => {
  const breadcrumbs = cloneDeep(INCENTIVES_BREADCRUMBS);
  breadcrumbs[breadcrumbs.length - 1].href = PAGE_URL.CAR_INCENTIVES;
  return breadcrumbs.concat([{ title: makeName }]);
};

export const getIncentivesTypeBreadcrumbs = typeSlug => {
  const breadcrumbs = cloneDeep(INCENTIVES_BREADCRUMBS);
  breadcrumbs[breadcrumbs.length - 1].href = PAGE_URL.CAR_INCENTIVES;
  return breadcrumbs.concat([{ title: getCarTypeNameBySlug(typeSlug) }]);
};

export const getElectricCarIncentivesBreadcrumbs = stateName =>
  stateName
    ? [...ELECTRIC_CAR_STATE_INCENTIVES_BREADCRUMBS, { title: stateName }]
    : ELECTRIC_CAR_INCENTIVES_BREADCRUMBS;
